
<template>
  <div id="landing-box" class="container-fluid px-0"  >
    <div v-if="!CargaCorrecta" class="caja-de-carga">
    <div class="justify-content-center "> 
        <div class="d-flex flex-wrap  justify-content-center">
          <figure  style="height:50vh;width:24vw;">
            <img style="height:100%;width:100%;" src="../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
          </figure>
          <div class="w-100 mb-5 justify-content-center text-center position-relative d-flex">
            <i v-if="!EnMantenimiento" class="fas fa-spinner fa-spin fa-5x" style="left: 0; right: 0;color: azure;"></i>
            <h2 v-else-if="EnMantenimiento"  style="color:white">LA PÁGINA DEL MICROSITIO NO HA SIDO ENCONTRADA</h2>
          </div>
        </div>  
    </div>
   </div> 

<div class="imagenfondo" v-bind:style="{'background-image': 'url(' + Pagina.Fondo + ')'}"></div>

<div v-if="ConSeguridad && !this.$store.getters.Get_SICPO_Micrositio_Login" class="col-12 mb-0 ">
   <div class="body login-restriccion" >
  <div class="login-form login-box">
    <div>
      <div style="width: 100%;display: flex;justify-content: center;">
     <img style="width:200px" src="../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" />
     </div>


        <!-- <h2 class="text-center">{{clave}}</h2>    -->
        <div class="form-group has-error">
          <label for="username" class="control-label label-login">Usuario</label>
        	<input type="text" v-model="usuario" class="form-control" name="username" placeholder="Usuario" required="required">
        </div>
		<div class="form-group">
      <label for="password" class="control-label label-login">Contraseña</label>
            <input type="password" v-model="password" class="form-control" name="password" placeholder="Password" required="required">
        </div>        
        <div class="form-group">
            <button type="submit" class="btn btn-info btn-lg btn-block" v-on:click="login">Entrar</button> 
        </div>
        <p v-if="errorLogin" class="error">CREDENCIALES INCORRECTAS</p>
    </div>
  
</div>
 </div>
</div>
    
<div v-else-if="Home && CargaCorrecta" id="landing-micrositio" class="row homeContenedor" >
      <HomeMicrositio :seccionesHome="Secciones" :comunicados="Comunicados" :paginainicio="PaginaInicio"></HomeMicrositio>
    </div>
    <!--FORMATOS DE PAGINA -->
    <div v-else>
      <h1 class="col-12 mb-0 page-title" v-if="Pagina.Titulo"  style="z-index:2">{{Pagina.Titulo}}</h1>
      <!--<div v-if="Pagina.Titulo == 'Cargando Información'" class="loading">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>-->
      

      <div v-bind:class="Pagina.Contenedor">
       
        <div class="row px-lg-5" >
          

     
          <div v-for="(seccion,index) in Secciones" :key="index" class="col-12"  id="seccionscont">
            <h2 v-if="seccion.Titulo !='' && seccion.Titulo!=null && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.TablaDescripcionYLink && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.TablaDeTexto && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.Pestanas && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.ContenidoConTabla && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.SelectSimple" class=" py-4 tituloSeccion">{{seccion.Titulo}}</h2>
            <div class="col-12 px-5" v-if="revisaFormato(seccion.TipoFormato.TipoFormatoId)">       
              <ListaVinculos v-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatos.ListaDeVinculos" :contenidos="seccion.ContenidoDeMicrositio"></ListaVinculos>                                                       
              <VinculosHover v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.VinculosHover" :contenidos="seccion.ContenidoDeMicrositio"></VinculosHover>                                     
              <TablaDescripcionYLink v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.TablaDescripcionYLink"  :contenidos="seccion.ContenidoDeMicrositio" :tituloSeccion="seccion.Titulo"></TablaDescripcionYLink>          
              <TablaDeTexto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.TablaDeTexto" :contenidos="seccion.ContenidoDeMicrositio" :titulos="seccion.Titulo"></TablaDeTexto>              
              <ContenidoEmbebido v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.ContenidoEmbebido"  :contenidos="seccion.ContenidoDeMicrositio"></ContenidoEmbebido>             
              <RouterHover v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.RouterHover" :contenidos="seccion.ContenidoDeMicrositio"></RouterHover>                                
              <Texto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Texto" :contenidos="seccion.ContenidoDeMicrositio"></Texto>
              <CarruselSimple v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.CarruselSimple"  :contenidos="seccion.ContenidoDeMicrositio"></CarruselSimple>
              <CarruselYTexto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.CarruselYTexto" :contenidos="seccion.ContenidoDeMicrositio"></CarruselYTexto> 
              <Imagen v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Imagen" :contenidos="seccion.ContenidoDeMicrositio"></Imagen> 
              <Video v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Video" :contenidos="seccion.ContenidoDeMicrositio"></Video>
              <CajaConVinculo v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.CajaConVinculo" :contenidos="seccion.ContenidoDeMicrositio"></CajaConVinculo>
              <ImagenConVinculo  v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.ImagenConVinculo" :contenidos="seccion.ContenidoDeMicrositio"></ImagenConVinculo> 
              <ImagenConTextoYLink v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.ImagenTextoLinkAlFinal" :contenidos="seccion.ContenidoDeMicrositio"></ImagenConTextoYLink> 
              <ListaTexto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.ListaTexto" :contenidos="seccion.ContenidoDeMicrositio"></ListaTexto>  
              <!-- <TextoContacto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Contacto" :contenidos="seccion.ContenidoDeMicrositio" :tituloSeccion="seccion.Titulo" :idTabla="index"></TextoContacto>             
               -->
              <ContenidoConTabla v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.ContenidoConTabla" :contenidos="seccion.ContenidoDeMicrositio" :tituloSeccion="seccion.Titulo"></ContenidoConTabla>
              <MapaContacto v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.MapaContacto" :contenidos="seccion.ContenidoDeMicrositio"></MapaContacto>
              <SelectMultiplesTablas v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Contacto" :secciones="seccion"></SelectMultiplesTablas>
        <!--  <div v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.Pestanas ">
              <Pestanas v-for="(grupo) in seccionesFormatoPestanas" :key="grupo.grupo" :Grupo="grupo"   :contenidos="seccion.ContenidoDeMicrositio" :tituloSeccion="seccion.Titulo" :idTabla="index" :seccionesCombo="seccionesFormatoPestanas" :ordenarPorMes="seccion.OrdenarPorMes" :Seccion="seccion"></Pestanas>            
              </div>  -->
              <VinculoModalMicrositio v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.VinculoModalMicrositio" :seccionDeMicrositio="seccion"></VinculoModalMicrositio>
              <SelectSimple v-else-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.SelectSimple" :contenidos="seccion.ContenidoDeMicrositio" :titulo="seccion.Titulo"></SelectSimple>
             
            </div>
          </div>

          <div v-for="(seccion,index) in seccionesFormatoPestanas" :key="'S'+index" class="col-12"  id="seccionscont">
            <!-- <h2 v-if="seccion.Titulo !='' && seccion.Titulo!=null && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.TablaDescripcionYLink && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.TablaDeTexto && seccion.TipoFormato.TipoFormatoId != enumeraciones_micrositios.TiposFormatoMicrositios.Pestanas" class=" py-4 tituloSeccion">{{seccion.Titulo}}</h2> -->
            <div class="col-12 px-5"> 
              <Pestanas  :Grupo="seccion"   :contenidos="seccion.ContenidoDeMicrositio" :tituloSeccion="seccion.Titulo" :idTabla="index" :seccionesCombo="seccionesFormatoPestanas" :ordenarPorMes="seccion.OrdenarPorMes" :Seccion="seccion"></Pestanas>            
            </div>      
          </div>

        </div>

      </div>

    </div>
    <!--FIN FORMATOS DE PAGINA -->
  </div>
</template>


<script>
  import api from '@/../static/js/api'
  import axios from 'axios'
  import carousel from 'vue-owl-carousel'
  import enumeraciones_micrositios from '@/../static/js/enumeraciones/sicpo.js'
  import ListaVinculos from '@/components/Micrositios/Formatos/ListaVinculos.vue'
  import VinculosHover from '@/components/Micrositios/Formatos/VinculosHover.vue'
  import TablaDescripcionYLink from '@/components/Micrositios/Formatos/TablaDescripcionYLink.vue'
  import TablaDeTexto from '@/components/Micrositios/Formatos/TablaDeTexto.vue'
  import ContenidoEmbebido from '@/components/Micrositios/Formatos/ContenidoEmbebido.vue'
  import RouterHover from '@/components/Micrositios/Formatos/RouterHover.vue'
  import Texto from '@/components/Micrositios/Formatos/Texto.vue'
  import CarruselSimple from '@/components/Micrositios/Formatos/CarruselSimple.vue'
  import CarruselYTexto from '@/components/Micrositios/Formatos/CarruselYTexto.vue'
  import Imagen from '@/components/Micrositios/Formatos/Imagen.vue'
  import Video from '@/components/Micrositios/Formatos/Video.vue'
  import CajaConVinculo from '@/components/Micrositios/Formatos/CajaConVinculo.vue'
  import ImagenConVinculo from '@/components/Micrositios/Formatos/ImagenConVinculo.vue'
  import ImagenConTextoYLink from '@/components/Micrositios/Formatos/ImagenConTextoYLink.vue'
  import ListaTexto from '@/components/Micrositios/Formatos/ListaTexto.vue'
  import TextoContacto from '@/components/Micrositios/Formatos/TextoContacto.vue'
  import HomeMicrositio from '@/components/Micrositios/HomeMicrositio.vue'
  import MapaContacto from '@/components/Micrositios/Formatos/MapaContacto.vue'
  import Pestanas from '@/components/Micrositios/Formatos/Pestanas.vue'
  import VinculoModalMicrositio from '@/components/Micrositios/Formatos/VinculoModalMicrositio.vue'
  import SelectMultiplesTablas from '@/components/Micrositios/Formatos/SelectMultiplesTablas.vue'
  import ContenidoConTabla from '@/components/Micrositios/Formatos/ContenidoConTabla.vue'
  import SelectSimple from '@/components/Micrositios/Formatos/SelectSimple.vue'
  import enumeraciones from "@/../static/js/enumeraciones";
  import comun from "@/../static/js/comun"




  export default {
    data() {
      return {
        Filtrado:false,
        usuario:'',
        password:'',
        GrupoSelect:[],
        Pagina: {
          Titulo: '',
          Presentacion: '',
          MenuMicrositio: '',
          Fondo:'',
          Contenedor:'',
          TituloMicrositio:''
          
        },
        PaginaInicio:'',         
        Secciones: [],
        Comunicados:[],     
        Home: false,
        ConSeguridad: false,
        Autentication:false,
        errorLogin:false,
        CargaCorrecta:false,
        Comunicados:[],
        EnMantenimiento:false,
        enumeraciones_micrositios,
        enumeraciones
      }
    },
     components: {
      carousel,ListaVinculos,VinculosHover,TablaDescripcionYLink,TablaDeTexto,CajaConVinculo,ImagenConTextoYLink,ListaTexto,TextoContacto,MapaContacto,
      ContenidoEmbebido,RouterHover,Texto,CarruselSimple,CarruselYTexto,Imagen,Video,ImagenConVinculo,HomeMicrositio,Pestanas,VinculoModalMicrositio,SelectMultiplesTablas,ContenidoConTabla,SelectSimple
    },
   
    methods: {
    
      HomePage() {
        var ruta = this.$route.path.split('/');
        this.TituloMicrositio = ruta[2]
        if (ruta[3] == 'Home') {
          return this.Home = true
        } 
        if((ruta[3] == 'Repositorio') ){
          return this.ConSeguridad = true
        }
        else {
          return this.Home = false
        }

      
      },
      async CargaPagina(paginaRoute) {
        let peticion = {
          Url: paginaRoute,
          EsPrueba: enumeraciones.EsPrueba
        }
         this.CargaDatosPagina(0,false,paginaRoute);
 /*       axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenIdMenuSubmenu, peticion).then(async response => {
          this.IdMenuOSubmenu = response.data.IdMenuOSubmenu.IdMenuOSubmenu;
          this.EsSubmenu = response.data.IdMenuOSubmenu.SubMenu;

          this.CargaDatosPagina(response.data.IdMenuOSubmenu.IdMenuOSubmenu,response.data.IdMenuOSubmenu.Submenu,paginaRoute);
        }).catch(e => {
          this.EnMantenimiento=true;
          console.log('Error de Pagina: ' + e)
        });  */
      },
      EstableceElTituloDeLaVentana: function(rutaPagina) {
        let tituloDeLaPaginaWeb = "Poder Judicial del Estado de Aguascalientes";

        if(Object.keys(this.Pagina).length > 0) {
          tituloDeLaPaginaWeb = this.TituloMicrositio+" - "+this.Pagina.Titulo + " - " + tituloDeLaPaginaWeb;
        }

        document.title = tituloDeLaPaginaWeb;
      },
      async CargaDatosPagina(MenuId,EsSubmenu,rutaPagina) {
        let peticion = {
          RutaDeAcceso:rutaPagina,
          idMenu: MenuId,
          ConSubmenu: false,
          EsPrueba: false  
        }
      
        return axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenPaginaDeMicrositio, peticion).then(async response => {
           if(response.data.EncontroError){
                 this.EnMantenimiento=true;
                 console.log('Mensage de la Pagina:'+response.data.Satisfactorio)
           }else{   
           console.log('DATOS DE LA PAGINA:',response.data)
          this.Pagina.Titulo = response.data.PaginaMicrositio.Titulo
          this.Pagina.Fondo = response.data.PaginaMicrositio.ImagenDeFondo
          this.Pagina.Contenedor = response.data.PaginaMicrositio.TipoContenedor.Nombre           
          this.PaginaInicio = response.data.PaginaMicrositio.PaginaDeInicio.TextoDePresentacion
          this.Secciones = response.data.PaginaMicrositio.SeccionesDePagina;
          var idPaginaInicio = response.data.PaginaMicrositio.PaginaDeInicio.PaginaDeInicioId;
          this.EstableceElTituloDeLaVentana(rutaPagina)
          
          if(this.Secciones==null || this.Secciones=='' ){
             console.log('Mensage de la Pagina: No se an encontrado secciones en la pagina')
          }

          if(this.Home )
          this.CargaComunicados(response.data.PaginaMicrositio.PaginaDeInicio.PaginaDeInicioId);   
          
          this.CargaCorrecta = true;
           }
        }).catch(e => {
          this.EnMantenimiento=true;
          
          console.log('A Ocurrido un error: ' + e)
        });
      },
       async CargaComunicados(idInicio){
          let peticion = {
            PaginaInicio:idInicio,
            SoloActivos:true,
            EntreFechas:true,
            EsPrueba:false
          }
        return axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenComunicadosMicrositios,peticion).then(async response =>{
  //console.log("CONMNUCIACCOAO:::",response.data.ComunicadosMicrositios)
  this.Comunicados = response.data.ComunicadosMicrositios
        
        }).catch(e => {
          console.log('A Ocurrido un error: ' + e)
        })

      },

revisaFormato(formatoActual){
        var Formatos = enumeraciones_micrositios.TiposFormatoMicrositios;
        var msg ="El formato no fue encontrado";
        var respuesta = false;
          for(var aux in Formatos){
            if(Formatos[aux] == formatoActual){
              msg = "El formato fue encontrado con exito";
              respuesta=true;
            }
          }
        console.log("Mensage de la Pagina: "+msg);
        return respuesta;
      },

    login(){
          let peticion = {
            usuario:this.usuario,
            password:this.password
          }//http://localhost:50037/
      // axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ValidarUsuario, peticion)
       axios.post("http://localhost:50037/" + api.SICPO.sistema.micrositioweb.oficialmicrositio.ValidarUsuario, peticion)
       .then(async response => {
        console.log("RESPUESTA DE LOGIN:::",response.data)
         if(response.data.usuarioValido){
           this.$store.dispatch("A_SICPO_Micrositio_Login",true);
           this.errorLogin=false;
         }else{
           this.errorLogin=true;
         }
                 
        }).catch(e => {
          console.log('Error de Pagina: ' + e)
        }); 


            // if(this.usuario == "usuario"  && this.password == "prueba"){
            //   this.$store.dispatch("A_SICPO_Micrositio_Login",true);
            // //this.Autentication=true; 
            // this.errorLogin=false;
            // }else{
            //     this.errorLogin=true;
            // }
      }

          
    },
    computed: {
      seccionesFormatoPestanas(){
        var titulosSecciones=[];

const filteredCategories = [];

this.Secciones.forEach(category => {
  if(category.TipoFormato.TipoFormatoId == 22){
        var aux = filteredCategories.find(find => find.grupo == category.NumeroDeAgrupacion);
        if(aux==undefined){
          let nuevo={
            grupo:category.NumeroDeAgrupacion,
            Secciones:[category]
          }
          filteredCategories.push(nuevo);   
        }else{
          let otro = filteredCategories.find(find => find.grupo == category.NumeroDeAgrupacion)
          otro.Secciones.push(category)
        }
  }
   
});

this.GrupoSelect = filteredCategories;

this.Filtrado = true;

        for(var secc in this.Secciones){
          
           if(this.Secciones[secc].TipoFormato.TipoFormatoId==22){
             titulosSecciones.push(this.Secciones[secc])
           }
        }
        
       //return titulosSecciones;
       return filteredCategories;

      }
    },
    mounted() {
      this.$store.state.MenuResponsivo = false;
      this.$store.state.MenuMicrositio = true;
      this.HomePage();   
      this.CargaPagina(this.$route.path);
    }
  }
</script>

<style scoped>

/* 
.row{
    display:-webkit-box !important;
}
.col-12{
    position: inherit !important;
} */
.login-restriccion{
    display:flex; 
    justify-content: center; 
   
}
.label-login{
  font-size: large;
  color: white;
}

.login-box{
  border-radius: 8px;
  margin: 6em;
  width: 30em;
  height: auto;
  padding: 1em;
  background-color:#4e4b4b;
}
 .error{
    background-color: red;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 18px;
    text-align: center;
    color: white;
    
}

.tituloSeccion{
  text-align: left;
  padding-left: 48px;
  font-family: 'AntenaBeta';
}
.caja-de-carga{
  background-color:rgba(0,117,115,.7);
  height:100%;
  width:100%;
  position:absolute;
}

.homeContenedor{
  margin-left: 10em;
  margin-right: 10em;
 
 
}

.contenido-home{
margin-right: 5em;
}

   .page-text{
        font-size:1.2em !important;

  }
  #seccionscont{
    background-color:rgba(255,255,255,.8);
  }

  #landing-micrositio {
    /* height: calc(100vh - 102px); */
    display: flex;
    align-items: center; 
    padding-top: 1rem;
  }

  .imagenfondo {
     bottom: 0;
    top: 0;
    left: 0;
    right: 0;

opacity: .7;
background-position: center;
 background-size: cover;
 background-repeat: no-repeat;

position: absolute;;
  }

  #landing-box {
    min-height: calc(100vh - 102px);
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
    position: relative;
    }

  .loading {
   width: 100%;
    font-size: 10em;
    height: calc(100vh - 200px);
    display: flex;
    align-items: center;
    justify-content: center; 
  }

  .page-title {
     
    font-family: 'AntenaBeta';
    background-color: rgb(0,117,115);
    color: #FFF;
    padding: 2vh 20vw; 

  }

  ul {
    padding-left: 20px;
  }

  a {
    color: rgb(33,33,33);
    font-weight: 500;
    cursor: pointer;
  }



  @media only screen and (max-width:991px){
.homeContenedor{
  margin-left: 0;
  margin-right: 0;

}


}


  @media (max-width: 600px) {
    .page-title {
      font-size: 2em;
    }

    h2 {
      font-size: 1.8em;
    }
  }
 
</style>




// WEBPACK FOOTER //
// src/components/Micrositios/Micrositio.vue